import { Component, OnInit, Input, forwardRef } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { MarvDateService } from '@marv/services';
import { MarvSectionTitleComponent, MarvMessageComponent } from '@marv/components';
import { MissionItem, MissionDetails, MissionItemHistoryComponent, PhotoGalleryListComponent, PhotoGalleryMission } from '@app/components';

@Component({
    selector: 'app-mission-details-activities',
    templateUrl: './activities.component.html',
    styleUrls: ['./activities.component.scss'],
    imports: [ 
        TranslatePipe, forwardRef(() => MarvSectionTitleComponent), forwardRef(() => MarvMessageComponent), 
        forwardRef(() => MissionItemHistoryComponent), forwardRef(() => PhotoGalleryListComponent) 
    ]
})
export class MissionDetailsActivitiesComponent  implements OnInit {

    @Input({alias : 'mission', required : true}) missionDetails: MissionDetails;

    missionsItems: Array<MissionItem> = [];
    photoGalleryMission: PhotoGalleryMission;
    
    constructor() { }

    ngOnInit() {
        let startDate = new Date();
        let endDate = new Date();
        
        let min = null;
        let max = null;
        for(let a of this.missionDetails.activities){
            if(!min || min > a.day){
                min = a.day;
            }
            if(!max || max < a.day){
                max = a.day;
            }
        }
       
        if(min && max){
            let start = MarvDateService.ToDate(min);
            let end = MarvDateService.ToDate(max);
            if(start && end){
                startDate = start;
                endDate = end;
            }
        } 
        
        this.missionsItems = this.missionDetails.getMissionsItems();
        this.photoGalleryMission = {
            missionId: this.missionDetails.missionId,
            startDate: startDate,
            endDate: endDate,
            operation: {
                id: this.missionDetails.operation.id,
                name: this.missionDetails.operation.name,
                typeOfMission: this.missionDetails.operation.typeOfMission,
                source: this.missionDetails.operation.source,
            }
        }
    }

    onSelectMission(missionItem: MissionItem){
        
    }
}
